import React, { useRef } from "react";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { TbEdit, TbSettings } from "react-icons/tb";
import { IoMdSearch } from "react-icons/io";

import styles from "@areas/shared/pages/personal/frames/statistics/contracts/blocks/styles/allTable.module.css";

function Table({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  toggleModal,
  onSearch,
}) {
  const searchRef = useRef();
  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Код</span>,
      selector: (row) => row.Id,
      sortable: true,
      width: "20%",
    },
    {
      name: <span className="font-weight-bold fs-13">ИНН</span>,
      selector: (row) => row.Inn,
      sortable: true,
      width: "20%",
    },
    {
      name: <span className="font-weight-bold fs-13">КПП</span>,
      selector: (row) => row.Kpp,
      sortable: true,
      width: "20%",
    },
    {
      name: <span className="font-weight-bold fs-13">Наименование</span>,
      selector: (row) => row.Shortname ? row.Shortname : row.Fullname,
      sortable: true,
      width: "40%",
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      width: "10%",
      center: true,
      compact: true,
      cell: (cellProps) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-outline-secondary btn-sm d-flex justify-content-center"
              tag="button"
            >
              <TbSettings size={18} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                className="edit-item-btn"
                onClick={() => toggleModal(cellProps)}
              >
                <TbEdit size={16} className="me-2" />
                Изменить
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const submitSearch = () => {
    onSearch(searchRef.current.value);
  };

  return (
    <>
      <div className={styles.search}>
        <input
          type="text"
          placeholder="Поиск по наименованию или ИНН"
          ref={searchRef}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submitSearch();
            }
          }}
        />
        <div
          className={`btn btn-outline-secondary ${styles.btn}`}
          onClick={submitSearch}
        >
          <IoMdSearch size={25} />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data}
        progressComponent={<ClipLoader />}
        progressPending={load}
        paginationTotalRows={total}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pagination
        paginationServer
        paginationComponentOptions={paginationOptions}
      />
    </>
  );
}

export default Table;
